module.exports = __webpack_public_path__ + "img/play.1d4223b4.png";